import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Situacao from '../../../../components/auth/licitacao/listar/form_situacao'


function SituacaoLicScreen() {

    return (
        <Fragment>
            <Head titulo="Editando Situação da Licitação" />
            <HeaderLogged />
            <Container>
               <Situacao />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default SituacaoLicScreen;